import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Input, ViewEncapsulation, Component, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

/**
 * To use this component in a module, you can import the `CentricBreadcrumbsModule`:
 * @example
 * ```typescript
 * import { CentricBreadcrumbsModule } from '@windmill/ng-windmill/breadcrumbs';
 * ```
 *
 * To use the standalone component directly, you can import `BreadcrumbsComponent`:
 * @example
 * ```typescript
 * import { BreadcrumbsComponent } from '@windmill/ng-windmill/breadcrumbs';
 * ```
 */
class BreadcrumbsComponent {
    /**
     * Sets the aria-label attribute
     */
    ariaLabel;
    /**
     * Sets the aria-labelledby attribute
     */
    ariaLabelledby;
    /**
     * Sets the aria-description attribute
     */
    ariaDescription;
    /**
     * Sets the aria-describedby attribute
     */
    ariaDescribedby;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: BreadcrumbsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: BreadcrumbsComponent, isStandalone: true, selector: "centric-breadcrumbs", inputs: { ariaLabel: "ariaLabel", ariaLabelledby: "ariaLabelledby", ariaDescription: "ariaDescription", ariaDescribedby: "ariaDescribedby" }, ngImport: i0, template: "<div class=\"centric-breadcrumbs\">\r\n  <nav\r\n    [attr.aria-label]=\"ariaLabel\"\r\n    [attr.aria-labelledby]=\"ariaLabelledby\"\r\n    [attr.aria-description]=\"ariaDescription\"\r\n    [attr.aria-describedby]=\"ariaDescribedby\">\r\n    <ng-content></ng-content>\r\n  </nav>\r\n  <section class=\"breadcrumbs-buttons\">\r\n    <ng-content select=\"[breadcrumbs-buttons]\"></ng-content>\r\n  </section>\r\n</div>\r\n", dependencies: [{ kind: "ngmodule", type: CommonModule }], encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: BreadcrumbsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'centric-breadcrumbs', encapsulation: ViewEncapsulation.None, imports: [CommonModule], standalone: true, template: "<div class=\"centric-breadcrumbs\">\r\n  <nav\r\n    [attr.aria-label]=\"ariaLabel\"\r\n    [attr.aria-labelledby]=\"ariaLabelledby\"\r\n    [attr.aria-description]=\"ariaDescription\"\r\n    [attr.aria-describedby]=\"ariaDescribedby\">\r\n    <ng-content></ng-content>\r\n  </nav>\r\n  <section class=\"breadcrumbs-buttons\">\r\n    <ng-content select=\"[breadcrumbs-buttons]\"></ng-content>\r\n  </section>\r\n</div>\r\n" }]
        }], propDecorators: { ariaLabel: [{
                type: Input
            }], ariaLabelledby: [{
                type: Input
            }], ariaDescription: [{
                type: Input
            }], ariaDescribedby: [{
                type: Input
            }] } });

const moduleComponents = [BreadcrumbsComponent];
class CentricBreadcrumbsModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricBreadcrumbsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: CentricBreadcrumbsModule, imports: [CommonModule, BreadcrumbsComponent], exports: [BreadcrumbsComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricBreadcrumbsModule, imports: [CommonModule, moduleComponents] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CentricBreadcrumbsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ...moduleComponents],
                    exports: [...moduleComponents],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { BreadcrumbsComponent, CentricBreadcrumbsModule };
